import React from "react";
import { __ } from '@wordpress/i18n';
import NextStepLink from '../../../../components/util/next-step-link/index';
import PreviousStepLink from '../../../../components/util/previous-step-link/index';

export const PALETTES = [
	{
		'text-color': '#1d53dd',
		'theme-color': '#0235b7',
		'link-color': '#1a1a1a',
		'link-hover-color': '#3f4047',
		'heading-color': '#f4f6fa',
	},
	{
		'text-color': '#c50529',
		'theme-color': '#b00726',
		'link-color': '#212121',
		'link-hover-color': '#3a3a3a',
		'heading-color': '#f5f2e9',
	},
	{
		'text-color': '#f1592b',
		'theme-color': '#ff4006',
		'link-color': '#293f56',
		'link-hover-color': '#2d3f51',
		'heading-color': '#fbf9f6',
	},
	{
		'text-color': '#ff4672',
		'theme-color': '#fd2658',
		'link-color': '#352515',
		'link-hover-color': '#2e3243',
		'heading-color': '#f9f8fb',
	},
	{
		'text-color': '#058466',
		'theme-color': '#046f56',
		'link-color': '#051145',
		'link-hover-color': '#3f4850',
		'heading-color': '#ecf0f2',
	},
	{
		'text-color': '#ffb727',
		'theme-color': '#ffac05',
		'link-color': '#212121',
		'link-hover-color': '#424242',
		'heading-color': '#f8f6ef',
	},
]

const SiteColorsAction = (props) => {
	const { onNextClick, onPreviousClick, customizeStep } = props;

	return (
		<>
			<PreviousStepLink customizeStep={customizeStep} onClick={onPreviousClick} before>{__('Back', 'astra-sites')}</PreviousStepLink>
			<NextStepLink ml1 customizeStep={customizeStep}
				onClick={(event) => {
					onNextClick();
				}}
				after
			>
				{__('Maybe Later', 'astra-sites')}
			</NextStepLink>
		</>
	)
}

export default SiteColorsAction;
